var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h2',[_vm._v("Historique des saisies")]),_c('el-alert',{attrs:{"title":"information","type":"info","description":"Le suivi conso n'est pas disponible pour l'instant dans cet outils.","show-icon":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }